var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28198 0.714561C8.31502 -0.247533 6.73645 -0.236778 5.7559 0.738848L4.99294 1.49798C4.88519 1.60518 4.88379 1.77796 4.99015 1.88378L5.38313 2.2748C5.48949 2.38062 5.66314 2.37923 5.77089 2.27202L6.51537 1.53128C7.05412 0.995244 7.92552 0.960549 8.46915 1.47646C9.02917 2.00765 9.03091 2.89966 8.47926 3.44853L6.4819 5.43587C6.00696 5.90841 5.27713 5.9726 4.74257 5.62634C4.63098 5.55418 4.48348 5.56805 4.38794 5.66277L3.99216 6.05656C3.87012 6.17799 3.88371 6.37818 4.0211 6.47811C4.99154 7.18519 6.37136 7.09394 7.2602 6.20991L9.25757 4.22258C10.2381 3.24695 10.2489 1.67631 9.28198 0.714214V0.714561Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2601 7.724L3.51562 8.46474C2.97687 9.00078 2.09989 9.02958 1.54859 8.50638C0.9809 7.96756 0.97288 7.06931 1.52453 6.52043L3.52189 4.5331C3.99683 4.06055 4.73119 4.00088 5.27203 4.35338C5.38501 4.42693 5.53356 4.41409 5.62875 4.31903L6.02453 3.92524C6.14658 3.80381 6.13158 3.60223 5.99245 3.50057C5.01016 2.78169 3.62127 2.86392 2.73278 3.7483L0.735413 5.73563C-0.245138 6.71125 -0.245138 8.293 0.735413 9.26828C1.71596 10.2439 3.3057 10.2439 4.2859 9.26828L5.04886 8.50915C5.15661 8.40194 5.15661 8.22812 5.04886 8.12057L4.65029 7.724C4.54255 7.6168 4.36785 7.6168 4.25975 7.724H4.2601Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.f5bd3b9058f535bf0dd5cbd2f11b07c6.svg";
export { ForwardRef as ReactComponent };